
import React from 'react';
import './NoAccess.css';

const NoAccess = () => (
  <>
    <div className="content blocking">
      <div className="title" id="msg_title"><b>CCAArchiveUI: Access Denied</b></div>
      <ul className="details">
        <li><b>Access has been blocked. Please contact Administrator for access.</b></li>
      </ul>
    </div>
    <div className="footer">CCAArchiveUI Security</div>
  </>
);

export default NoAccess;
